import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var Files =
/*#__PURE__*/
function () {
  function Files() {
    _classCallCheck(this, Files);
  }

  _createClass(Files, [{
    key: "GetFiles",
    value: function () {
      var _GetFiles = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(managementCompanyId, propertyId, statusId, moduleName, moduleId, subModuleName, subModuleId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/File", {
                  params: {
                    managementCompanyId: managementCompanyId,
                    propertyId: propertyId,
                    statusId: statusId,
                    moduleName: moduleName,
                    moduleId: moduleId,
                    subModuleName: subModuleName,
                    subModuleId: subModuleId
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetFiles(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _GetFiles.apply(this, arguments);
      }

      return GetFiles;
    }()
  }, {
    key: "GetDocuwareViewerUrl",
    value: function () {
      var _GetDocuwareViewerUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(docId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/File/GetDocuwareViewerUrl", {
                  params: {
                    docId: docId
                  },
                  doNotShowLoading: true
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetDocuwareViewerUrl(_x8) {
        return _GetDocuwareViewerUrl.apply(this, arguments);
      }

      return GetDocuwareViewerUrl;
    }()
  }, {
    key: "GetDocuwareUrl",
    value: function () {
      var _GetDocuwareUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(managementCompanyId, propertyId, moduleName, moduleId, subModuleName, subModuleId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/File/GetDocuwareUrl", {
                  params: {
                    managementCompanyId: managementCompanyId,
                    propertyId: propertyId,
                    moduleName: moduleName,
                    moduleId: moduleId,
                    subModuleName: subModuleName,
                    subModuleId: subModuleId
                  },
                  doNotShowLoading: true
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetDocuwareUrl(_x9, _x10, _x11, _x12, _x13, _x14) {
        return _GetDocuwareUrl.apply(this, arguments);
      }

      return GetDocuwareUrl;
    }()
  }, {
    key: "Upload",
    value: function () {
      var _Upload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(files, managementCompanyId, propertyId, title, statusId, moduleName, moduleId, documentType, subModuleName, subModuleId, merge, moduleUniqueName) {
        var internalToMHDC,
            formData,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                internalToMHDC = _args4.length > 12 && _args4[12] !== undefined ? _args4[12] : false;
                formData = new FormData();
                if (files.length) files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                if (managementCompanyId) formData.append("managementCompanyId", managementCompanyId);
                if (propertyId) formData.append("propertyId", propertyId);
                formData.append("title", title);
                formData.append("statusId", statusId);
                formData.append("moduleName", moduleName);
                formData.append("moduleId", moduleId);
                formData.append("internalToMHDC", internalToMHDC);
                if (subModuleName) formData.append("subModuleName", subModuleName);
                if (subModuleId) formData.append("subModuleId", subModuleId);
                if (documentType) formData.append("documentType", documentType);
                if (merge) formData.append("merge", merge);
                if (moduleUniqueName) formData.append("moduleUniqueName", moduleUniqueName);
                return _context4.abrupt("return", axios.post("/api/File/Upload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function Upload(_x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24, _x25, _x26) {
        return _Upload.apply(this, arguments);
      }

      return Upload;
    }()
  }, {
    key: "UploadAndGetId",
    value: function () {
      var _UploadAndGetId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(files, managementCompanyId, propertyId, title, statusId, moduleName, moduleId, documentType, subModuleName, subModuleId, merge, moduleUniqueName) {
        var internalToMHDC,
            formData,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                internalToMHDC = _args5.length > 12 && _args5[12] !== undefined ? _args5[12] : false;
                formData = new FormData();
                if (files.length) files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                if (managementCompanyId) formData.append("managementCompanyId", managementCompanyId);
                if (propertyId) formData.append("propertyId", propertyId);
                formData.append("title", title);
                formData.append("statusId", statusId);
                formData.append("moduleName", moduleName);
                formData.append("moduleId", moduleId);
                formData.append("internalToMHDC", internalToMHDC);
                if (subModuleName) formData.append("subModuleName", subModuleName);
                if (subModuleId) formData.append("subModuleId", subModuleId);
                if (documentType) formData.append("documentType", documentType);
                if (merge) formData.append("merge", merge);
                if (moduleUniqueName) formData.append("moduleUniqueName", moduleUniqueName);
                return _context5.abrupt("return", axios.post("/api/File/UploadAndGetId", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function UploadAndGetId(_x27, _x28, _x29, _x30, _x31, _x32, _x33, _x34, _x35, _x36, _x37, _x38) {
        return _UploadAndGetId.apply(this, arguments);
      }

      return UploadAndGetId;
    }()
  }, {
    key: "DownloadFile",
    value: function () {
      var _DownloadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(docId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/File/DownloadFile/".concat(docId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function DownloadFile(_x39) {
        return _DownloadFile.apply(this, arguments);
      }

      return DownloadFile;
    }()
  }, {
    key: "DeleteFile",
    value: function () {
      var _DeleteFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(docId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/File/DeleteFile/".concat(docId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function DeleteFile(_x40) {
        return _DeleteFile.apply(this, arguments);
      }

      return DeleteFile;
    }()
  }]);

  return Files;
}();

export default new Files();